import Vue from 'vue'
import VueRouter from 'vue-router'
const app = () => import('../views/index/index.vue');
const chathere = () => import('../views/chathere/chathere.vue');
const collection = () => import('../views/chathere/collection.vue');
const chatsearch = () => import('../views/chathere/chatsearch.vue');
const yjfk = () => import('../views/chathere/yjfk.vue');
const chatherepc = () => import('../views/chatherepc/chathere.vue');
const collectionpc = () => import('../views/chatherepc/collection.vue');
const chatsearchpc = () => import('../views/chatherepc/chatsearch.vue');
const yjfkpc = () => import('../views/chatherepc/yjfk.vue');
const demo = () => import('../views/demo/chathere.vue');
const collectiondemo = () => import('../views/demo/collection.vue');
const chatsearchdemo = () => import('../views/demo/chatsearch.vue');
const yjfkdemo = () => import('../views/demo/yjfk.vue');
// const svcmgr = () => import('../views/svcmgr/chathere.vue');
const collectionsvcmgr = () => import('../views/svcmgr/collection.vue');
const chatsearchsvcmgr = () => import('../views/svcmgr/chatsearch.vue');
const yjfksvcmgr = () => import('../views/svcmgr/yjfk.vue');
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'idnex',
		component: app
	},
	{
		path: '/chathere',
		name: 'chathere',
		meta: { title: "自动客服体验", keepAlive: true },
		component: chathere
	},
	{
		path: '/yjfk',
		name: 'yjfk',
		meta: { title: "意见反馈" },
		component: yjfk
	},
	{
		path: '/collection',
		name: 'collection',
		meta: { title: "全部收藏" },
		component: collection
	},
	{
		path: '/chatsearch',
		name: 'chatsearch',
		meta: { title: "历史搜索" },
		component: chatsearch
	},
	{
		path: '/chatherepc',
		name: 'chatherepc',
		meta: { title: "自动客服体验", keepAlive: true },
		component: chatherepc
	},
	{
		path: '/yjfkpc',
		name: 'yjfkpc',
		meta: { title: "意见反馈" },
		component: yjfkpc
	},
	{
		path: '/collectionpc',
		name: 'collectionpc',
		meta: { title: "全部收藏" },
		component: collectionpc
	},
	{
		path: '/chatsearchpc',
		name: 'chatsearchpc',
		meta: { title: "历史搜索" },
		component: chatsearchpc
	},
	{
		path: '/chat',
		name: 'demo',
		meta: { title: "自动客服体验", keepAlive: true },
		component: demo
	},
	{
		path: '/yjfkdemo',
		name: 'yjfkdemo',
		meta: { title: "意见反馈" },
		component: yjfkdemo
	},
	{
		path: '/collectiondemo',
		name: 'collectiondemo',
		meta: { title: "全部收藏" },
		component: collectiondemo
	},
	{
		path: '/chatsearchdemo',
		name: 'chatsearchdemo',
		meta: { title: "历史搜索" },
		component: chatsearchdemo
	},
	// {
	// 	path: '/svcmgr',
	// 	name: 'svcmgr',
	// 	meta: { title: "AI", keepAlive: true },
	// 	component: svcmgr
	// },
	{
		path: '/yjfksvcmgr',
		name: 'yjfksvcmgr',
		meta: { title: "意见反馈" },
		component: yjfksvcmgr
	},
	{
		path: '/collectionsvcmgr',
		name: 'collectionsvcmgr',
		meta: { title: "全部收藏" },
		component: collectionsvcmgr
	},
	{
		path: '/chatsearchsvcmgr',
		name: 'chatsearchsvcmgr',
		meta: { title: "历史搜索" },
		component: chatsearchsvcmgr
	},
]


const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	} else {
		document.title = '至像打印'
	}
	next()
})

export default router
